import { Box } from '@wishket/design-system';

import { Skeleton } from '@/shared/Components';

const AuthorListSkeleton = () => {
  return (
    <Box className="flex w-full flex-col gap-6">
      {Array.from({ length: 10 }).map((_, index) => (
        <Skeleton key={index} className="h-[184px]" grayScale={100} />
      ))}
    </Box>
  );
};

export default AuthorListSkeleton;
